import React from 'react';
import PropTypes from 'prop-types';

// Constants
import { EMAIL_RECIPIENTS_LIMIT } from 'constants/groups';

// Utils
import { GroupPropTypes } from 'utils/PropTypesValues';

// Components
import Button from 'sharedComponents/Button';
import MainHeader from 'sharedComponents/MainHeader';
import PageLayout from 'sharedComponents/PageLayout';
import ClientInfiniteScrollList from 'sharedComponents/ClientInfiniteScrollList';
import Preloader from 'sharedComponents/Preloader';
import EmailRecipientItem from '../GroupEmailRecipientsItem';

const GroupEmailRecipientsList = ({
  classes,
  groupId,
  emailRecipientsLimit,
  fetchGroupClients,
  fetchGroupDetails,
  groupData,
  groupDataLoading,
  onClose,
  onEmailRecipientsConfirmed,
  initialSelectedRecipientsAmount,
}) => {
  const recalculatedRecipientsLimit = emailRecipientsLimit - initialSelectedRecipientsAmount;
  const [selectedClients, setSelectedClients] = React.useState([]);

  React.useEffect(() => {
    fetchGroupDetails({ groupId });
  }, []);

  const fetch = (from, size) => {
    return fetchGroupClients(groupId, { from, size });
  };

  const handleSelectedClients = (client) => {
    if (selectedClients.find(({ profileId }) => profileId === client.profileId)) {
      setSelectedClients(selectedClients.filter(({ profileId }) => profileId !== client.profileId));
    } else if (selectedClients.length < recalculatedRecipientsLimit) {
      setSelectedClients([...selectedClients, client]);
    }
  };

  if (groupDataLoading) return <Preloader />;

  return (
    <>
      {/* HEADER */}
      <MainHeader closeIcon="back" onClose={onClose} title={groupData?.name} />
      <div className={classes.subheader}>Select up to {emailRecipientsLimit} clients to send this message to.</div>

      {/* BODY */}
      <PageLayout padding="0 0 20px 0">
        <ClientInfiniteScrollList
          displayAlphabet={false}
          fetch={fetch}
          groupId={groupId}
          selectClient={handleSelectedClients}
          selectedClients={selectedClients}
          selectionEnabled
          itemRenderer={(props) => <EmailRecipientItem {...props} emailRecipientsLimit={recalculatedRecipientsLimit} />}
        />
      </PageLayout>

      {/* FOOTER */}
      <div className={classes.confirmation}>
        <Button disabled={!selectedClients.length} onClick={() => onEmailRecipientsConfirmed(selectedClients)}>
          Continue
        </Button>
      </div>
    </>
  );
};

GroupEmailRecipientsList.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  emailRecipientsLimit: PropTypes.number,
  fetchGroupClients: PropTypes.func.isRequired,
  fetchGroupDetails: PropTypes.func.isRequired,
  groupData: GroupPropTypes,
  groupDataLoading: PropTypes.bool.isRequired,
  groupId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onEmailRecipientsConfirmed: PropTypes.func.isRequired,
  initialSelectedRecipientsAmount: PropTypes.number,
};

GroupEmailRecipientsList.defaultProps = {
  classes: {},
  emailRecipientsLimit: EMAIL_RECIPIENTS_LIMIT,
  onClose: () => {},
  initialSelectedRecipientsAmount: 0,
};

export default GroupEmailRecipientsList;
